import { ClipboardCheck, KeyRound } from "lucide-react";

export type PlatformSection = "reviews" | "signer";

const sections: Array<{ id: PlatformSection; href: string; label: string; icon: typeof KeyRound }> = [
  { id: "reviews", href: "/console/platform/onboarding", label: "Workspace reviews", icon: ClipboardCheck },
  { id: "signer", href: "/console/platform/signer", label: "Signer & keys", icon: KeyRound },
];

export function PlatformNav({ active }: { active: PlatformSection }) {
  return <nav className="pr-subnav" aria-label="Platform administration">
    {sections.map(({ id, href, label, icon: Icon }) => <a key={id} href={href} className={active === id ? "active" : ""} aria-current={active === id ? "page" : undefined}><Icon />{label}</a>)}
  </nav>;
}
